import React from 'react';
import replaceTemplating from '../replaceTemplating';
function processText(text, props) {
  var regexp = /{{{(.*?)}}}/g;
  var output = text;
  if (typeof text === 'string') {
    var replacements = text.match(regexp);
    output = replaceTemplating(text, replacements, props);
  }
  if (typeof output === 'string') {
    output = output.split('\n').flatMap(function (output, i) {
      return [i > 0 && React.createElement("br", {
        key: i
      }), output];
    });
  } else {
    output = 'There was a problem rendering the terms and conditions. Please check again later.';
  }
  return output;
}
export default processText;